import React from 'react';
import { useApp } from '../context/AppContext';

// Muestra el beneficiario de forma CONFIDENCIAL: solo el master (o un rol con el
// permiso `ver_beneficiarios`) ve los nombres. Los demás ven "Confidencial" + la
// fecha de última actualización, para poder decirle al cliente cuándo se actualizó
// sin ver quiénes son. Ver src/context/AppContext (puedeVerBeneficiarios).
export default function BeneficiarioConfidencial({ nombre, cedula, actualizadoEl, nameStyle, subStyle }) {
  const { puedeVerBeneficiarios } = useApp();
  if (puedeVerBeneficiarios) {
    return (
      <>
        <div style={nameStyle}>{nombre || '—'}</div>
        {cedula ? <div style={subStyle}>{cedula}</div> : null}
      </>
    );
  }
  return (
    <>
      <div style={{ ...(nameStyle || {}), fontStyle: 'italic', color: 'var(--silver)' }}>Confidencial</div>
      <div style={subStyle}>{actualizadoEl ? `Actualizado: ${actualizadoEl}` : 'Sin registro de fecha'}</div>
    </>
  );
}
